import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {ModalService} from '@app/components/modal/modal.service';
import {ConditionTemplateComponent} from '../condition-template/condition-template.component';
import {NgFor, NgIf} from '@angular/common';
import {FinancialCondition, FinancialSetupCreationDto} from "@app/pages/quote/standard-quote/model/financial-setup.model";
import {FormBuilder, FormGroup} from "@angular/forms";
import {isTemplateDiagnostic} from "@angular/compiler-cli/src/ngtsc/typecheck/diagnostics";
import {AppCommonModule} from "@components/app.common.module";
import { TippyDirective } from '@ngneat/helipopper';
import { AuthService } from "@app/common/auth.service";
import { Permission } from "@app/models/permissions.enum";
import { RolesInternal } from "@app/models/roles.enum";

@Component({
  selector: 'app-conditions',
  standalone: true,
  templateUrl: './conditions.component.html',
  styleUrls: ['./conditions.component.css'],
  imports: [ConditionTemplateComponent, NgIf, NgFor, AppCommonModule, TippyDirective]
})
export class ConditionsComponent implements OnInit {
  @ViewChild('modalTemplate') modalTemplate!: TemplateRef<any>;
  @ViewChild('templateConfirmation') template!: TemplateRef<any>;
  @Output() saveConditions = new EventEmitter<FinancialCondition[]>();

  @Input() financialConditions: FinancialCondition[] = [];
  financialConditionDeleted: FinancialCondition;
  @Output() financialConditionsChange = new EventEmitter<FinancialCondition[]>();
  @Input() isReadyToEdit: boolean = false;
  @Input() financialSetup: FinancialSetupCreationDto;
  @Input() allowCapitalGrace: boolean = false;
  @Input() allowInterestGrace: boolean = false;
  form: FormGroup;
  item: FinancialCondition;
  isEdit: boolean = false;
  title: string = 'Eliminar Condición';
  subtitle: string = '';
  btn1: string = 'Cancelar';
  btn2: string = 'Eliminar';
  
  constructor(
    private modalService: ModalService,
    private authService: AuthService
  ) {

  }

  ngOnInit() {
  }

  // Método para verificar si el usuario es supervisor
  isSupervisorRole(): boolean {
    return this.authService.checkRoleFromParentMenu(
      Permission.financialSetup,
      RolesInternal.supervisor
    );
  }

  // Método para verificar si se pueden mostrar las acciones
  canShowActions(): boolean {
    return !this.isSupervisorRole();
  }


  openModal() {
    this.isEdit = false;
    this.modalService.component = this.modalTemplate;
    this.modalService.openModal();
  }

  close() {
    this.modalService.closeModal();
  }

  addCondition(data: any) {
    const financialCondition: FinancialCondition = data;
    financialCondition.term = parseInt(String(financialCondition.term));
    if (this.financialConditions.find((condition) => condition.term === financialCondition.term && condition.id === financialCondition.id)) {
      this.financialConditions = this.financialConditions.map((condition) => {
        if (condition.term === financialCondition.term && condition.id === financialCondition.id) {
          if (condition.term !== financialCondition.term) {
            return {...financialCondition, id: null}
          } else {
            return financialCondition;
          }
        }
        return condition;
      });
    } else {
      this.financialConditions.push({...financialCondition, id: null});
    }
    this.financialConditions = this.financialConditions.sort((a, b) => a.term - b.term);
    this.saveConditions.emit(this.financialConditions);
  }

  edit(financialCondition: FinancialCondition) {
    this.openModal();
    this.item = financialCondition;
    this.isEdit = true;
  }

  delete(financialCondition: FinancialCondition) {
    this.financialConditionDeleted = financialCondition;
    this.subtitle = `¿Estás seguro de que deseas eliminar la condición de plazo ${financialCondition.term}?`;
    this.modalService.component = this.template;
    this.modalService.openModal();

  }

  deleteModalFinancialCondition(){
    if (this.financialConditionDeleted) {
      this.financialConditions = this.financialConditions.filter((condition) => condition !== this.financialConditionDeleted);
      this.saveConditions.emit(this.financialConditions);
    }
    this.modalService.closeModal();
  }

  closeModal() {
    this.modalService.closeModal();
  }

  isApproved(){
    if (!this.financialSetup) return false;
    return 'APPROVED' === this.financialSetup?.status;
  }

}
